import { render } from "./FeedTable.vue?vue&type=template&id=845f992c&scoped=true"
import script from "./FeedTable.vue?vue&type=script&lang=js"
export * from "./FeedTable.vue?vue&type=script&lang=js"

import "./FeedTable.vue?vue&type=style&index=0&id=845f992c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-845f992c"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
